import { RetirementType } from "@type/HRM/retirement";
import { CREATE_RETIREMENT, GET_RETIREMENT } from "./types";

export const createRetirementRequest = (data: RetirementType) => {
  return {
    type: CREATE_RETIREMENT.CREATE_RETIREMENT_REQUEST,
    payload: {
      data,
    },
  } as const;
};

export const createRetirementSuccess = (data: RetirementType) => {
  return {
    type: CREATE_RETIREMENT.CREATE_RETIREMENT_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const createRetirementFailed = () => {
  return {
    type: CREATE_RETIREMENT.CREATE_RETIREMENT_FAILED,
  } as const;
};

export const getRetirementRequest = (retirementID: string | number) => {
  return {
    type: GET_RETIREMENT.GET_RETIREMENT_REQUEST,
    payload: { retirementID },
  } as const;
};

export const getRetirementSuccess = (data: RetirementType) => {
  return {
    type: GET_RETIREMENT.GET_RETIREMENT_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const getRetirementFailed = () => {
  return {
    type: GET_RETIREMENT.GET_RETIREMENT_FAILED,
  } as const;
};

export type RetirementActions =
  | ReturnType<typeof createRetirementRequest>
  | ReturnType<typeof createRetirementSuccess>
  | ReturnType<typeof createRetirementFailed>
  | ReturnType<typeof getRetirementRequest>
  | ReturnType<typeof getRetirementSuccess>
  | ReturnType<typeof getRetirementFailed>;
